import * as React from "react";

export type AiOutlineBtnProps = {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  /** Quiet tonal fill for the primary action only. */
  primary?: boolean;
  className?: string;
  "aria-label"?: string;
  type?: "button" | "submit";
};

/** WordPlugin SmallAction-style outline button. */
export const AiOutlineBtn: React.FC<AiOutlineBtnProps> = ({
  children,
  onClick,
  disabled,
  primary,
  className,
  "aria-label": ariaLabel,
  type = "button",
}) => (
  <button
    type={type}
    className={`ai-outline-btn${primary ? " ai-outline-btn--primary" : ""}${className ? ` ${className}` : ""}`}
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel}
  >
    {children}
  </button>
);

export default AiOutlineBtn;
